import React, { useEffect } from 'react';
import { END_EXIT_GAME_NOTIFICATION_DIALOG_DURATION_IN_SECONDS } from '../constants/Constants';

interface EndExitGameNotificationDialogProps {
    title: string;
    subtitle: string;
    closeDialog: any;
};

function EndExitGameNotificationDialog({title, subtitle, closeDialog}: EndExitGameNotificationDialogProps) {

    useEffect(() => {
        setTimeout(() => {
            closeDialog();
        }, END_EXIT_GAME_NOTIFICATION_DIALOG_DURATION_IN_SECONDS * 1000)
    }, [])

    return (
        <div className="endExitGameNotificationDialogWrapper">
            <h1 className="endExitGameNotificationDialogTitle">{title}</h1>
            <div className="endExitGameNotificationDialogSubtitle">{subtitle}</div>
        </div>
    );
};

export default EndExitGameNotificationDialog;